import { Outlet } from 'react-router-dom'
import { Footer } from '@/components/Footer/Footer'
import { Header } from '@/components/Header/Header'
import { useScrollToTop } from '@/hooks/useScrollToTop'
import './Layout.css'

export function Layout() {
  useScrollToTop()

  return (
    <div className="layout">
      <Header />

      <main className="layout__main">
        <Outlet />
      </main>

      <Footer />
    </div>
  )
}
